import "./ColorPicker.css";

import type { CSSProperties } from "react";
import type { ColorProp } from "../components";
import type { NoteColor } from "../noteCard/NoteCard";

export type ColorPickerColor = NoteColor;

export type ColorPickerChangeEvent = { value: ColorPickerColor };

export interface ColorPickerProps {
  colors?: ColorPickerColor[];
  value?: ColorPickerColor;
  onChange?: (event: ColorPickerChangeEvent) => void;
}

export const DEFAULT_COLORS: ColorPickerColor[] = [
  "white",
  "green",
  "cyan",
  "purple",
  "orange",
  "red",
];

export function getCustomProperties(color: ColorProp, isChecked: boolean) {
  switch (color) {
    case "white":
      return [
        "var(--color-white)",
        isChecked ? "var(--color-neutral-40)" : "var(--color-neutral-20)",
      ];
    default:
      return [
        `var(--color-${color}-10)`,
        isChecked ? `var(--color-${color}-30)` : `var(--color-${color}-10)`,
      ];
  }
}

export function ColorPicker({
  colors = DEFAULT_COLORS,
  onChange,
  value,
}: ColorPickerProps) {
  return (
    <div className="ColorPicker" role="radiogroup">
      {colors?.map((color) => {
        const isChecked = color === value;
        const [backgroundColor, borderColor] = getCustomProperties(
          color,
          isChecked,
        );
        const customProperties = {
          "--background-color": backgroundColor,
          "--border-color": borderColor,
        } as CSSProperties;

        function handleClick() {
          onChange?.({ value: color });
        }

        return (
          <div
            key={color}
            className="ColorPicker__item"
            style={customProperties}
            role="radio"
            tabIndex={0}
            aria-checked={isChecked}
            aria-label={color}
            onClick={handleClick}
          />
        );
      })}
    </div>
  );
}
